import Content from 'components/common/Content-v2';
import MainTitle from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import AddGuideForm from 'components/forms/guides/add';
import { useIntl } from 'react-intl';
const AddMember = props => {
	const { formatMessage } = useIntl();
	return (
		<>
			<MainTitle>
				<h1>{formatMessage({ id: 'dashboard.addGuide' })}</h1>
				<LinkButton to="/admin/guides"> {formatMessage({ id: 'commons.back' })} </LinkButton>
			</MainTitle>
			<Content>
				<AddGuideForm />
			</Content>
		</>
	);
};
export default AddMember;
